<template>
	<div class="panel">
		<div class="container my-4">
			<div class="about-school">
				<PanelThemesHeader title="О Школе" :with-themes="false">
					<template #link-button>
						<ArrowButton url="/about-school/" class="d-none d-lg-block">
							Подробнее
						</ArrowButton>
						<span class="d-flex d-lg-none title mb-0 icon-chevron-thin-right" />
					</template>
				</PanelThemesHeader>
				<div class="row">
					<div class="col-12">
						<div class="row">
							<div class="col-6 col-lg-3 about-school__header">
								<div class="title title-lg mb-0">
									70 000+
								</div>
								<span>слушателей образовательных программ</span>
							</div>
							<div class="col-6 col-lg-3 about-school__header">
								<div class="title title-lg mb-0">
									7 000+
								</div>
								<span>выпускников дипломных программ</span>
							</div>
							<div class="col-6 col-lg-3 about-school__header">
								<div class="title title-lg mb-0">
									150+
								</div>
								<span>профессоров и экспертов</span>
							</div>
							<div class="col-6 col-lg-3 about-school__header">
								<div class="title title-lg mb-0">
									80+
								</div>
								<span>образовательных программ</span>
							</div>
						</div>
					</div>
					<div class="col-12">
						<a
							href="https://www.skolkovo.ru/skolkovotour2025/#pano1199/42.0/0.0/75.0"
							target="_blank"
							class="header "
						>
							<div
								class="about-school__body header_wrapper relative"
								:class="filterActive"
								:style="headerStyle"
							>
								<client-only v-if="videosSource && safariAgent">
									<picture id="video" class="embed-responsive embed-responsive-16by9">
										<source class="embed-responsive-item" :srcset="videosSource" type="video/mp4">
										<img :src="`${banner}`">
									</picture>
								</client-only>

								<client-only v-if="videosSource && !safariAgent">
									<video
										id="video"
										playsinline
										muted
										autoplay
										preload="auto"
										loop
										class="embed-responsive embed-responsive-16by9"
										:poster="`${banner}`"
									>
										<source :src="videosSource" class="embed-responsive-item" type="video/mp4">
									</video>
								</client-only>
								<div class="play_button">
									<!-- <PlayRounded class="about-school__play mb-4 d-none d-md-block" /> -->
									<span class="d-flex icon-play-rounded mb-3" />
									<div class="title title-lg mb-0 text-center">
										Тур по Кампусу
									</div>
								</div>
							</div>
						</a>
					</div>
				</div>
			</div>
			<div class="row mt-3 d-none">
				<div class="col-6 col-lg-3">
					<div class="about-school__card">
						<div class="title title-lg">
							25 000 000+
						</div>
						<span>₽ собрано на развитие Школы</span>
					</div>
				</div>
				<div class="col-6 col-lg-3">
					<div class="about-school__card">
						<div class="title title-lg">
							25+
						</div>
						<span>исследовательских программ спонсировано</span>
					</div>
				</div>
				<div class="col-6 col-lg-3 mt-3 mt-lg-0">
					<div class="about-school__card">
						<div class="title title-lg">
							1 200 000+
						</div>
						<span>₽ собрано грантов поступающим</span>
					</div>
				</div>
				<nuxt-link to="/donation/" class="col-6 col-lg-3 mt-3 mt-lg-0">
					<div class="about-school__card about-school__card-button">
						<span>Стать меценатом</span>
					</div>
				</nuxt-link>
			</div>
		</div>
	</div>
</template>

<script>
import panel from '~/mixins/panel';
import PanelThemesHeader from '~/components/panels/system/PanelThemesHeader.vue';
import ArrowButton from '~/components/buttons/ArrowButton.vue';
import PlayRounded from '~/static/svg/play-rounded.vue';
import { EVENT_FORM_SCENARIOS, HEADER_IMAGE_POSITIONS, BOOTSTRAP_BREAKPOINTS } from '@/utils/dictionaries';

export default {
	name: 'PanelAboutSchool',
	components: {
		PlayRounded,
		ArrowButton,
		PanelThemesHeader,
	},
	mixins: [panel],
	data() {
		return {
			videosSource: '',
			headerStyle: '',
			poster: '',
			color: '',
			filterActive: '',
			headerImagePosition: '',
			safariAgent: null,
		};
	},
	computed: {
		banner() {
			return this.fetchedData?.top_cover_image_default?.src || '';
		},
	},
	watch: {
		screenWidth() {
			this.loadStyles();
		},
	},
	created() {
		this.headerImagePosition = HEADER_IMAGE_POSITIONS[1];
	},
	mounted() {
		if (process.client) {
			this.browserDetect();
			this.initVideo();
		}
		if (document.readyState === 'complete') {
			this.loadStyles();
		} else {
			window.addEventListener('load', this.loadStyles, {
				once: true,
				passive: true,
			});
		}
	},
	methods: {

		browserDetect() {
			if (navigator.vendor && navigator.userAgent) {
				this.safariAgent = navigator.vendor.includes('Apple')
					&& !navigator.userAgent.includes('CriOS')
					&& !navigator.userAgent.includes('FxiOS');
			}
		},
		initVideo() {
			// if (this.fetchedData.video_mp4) {
			// this.videosSource = `${this.fetchedData.video_mp4}`;
			this.videosSource = 'https://sk.skolkovo.ru/storage/file_storage/041efaf5-f8cf-48bb-ad40-8d68956c0302/Skolkovo-2025-4-Best.mp4';
			// }
		},
		loadStyles() {
			// if (this.fetchedData.video_mp4) {
			// this.filterActive = "filter";
			// if (this.fetchedData.color) {
			// 	this.headerStyle = `--new-color: ${this.fetchedData.color}`;
			// }
			// } else {
			// 	if (!this.fetchedData.mobile_image.startsWith('https')) {
			// 		this.headerStyle = `background-image:url(${this.fetchedData.top_cover_image_url_default})`;
			// 	} else if (this.screenWidth > this.BOOTSTRAP_BREAKPOINTS.md) {
			// 		this.headerStyle = `background-image:url(${this.fetchedData.top_cover_image_url_default})`;
			// 	} else {
			// 		this.headerStyle = `background-image:url(${this.fetchedData.mobile_image}); background-position: ${this.headerImagePosition}`;
			// 	}
			// }
		},
	},
};
</script>
<style lang="scss" scoped>
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";
@import "~/assets/styles/components/home/prog-header";

.header {
	.header_block {
		z-index: 2;
	}
	.filter {
		position: relative;
		&::before {
			content: '';
			display: block;
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			aspect-ratio: 1 / 1;
			background-color: var(--new-color, $primary) !important;
			mix-blend-mode: multiply;
			z-index: 1;
		}
	}
	#video {
		border-radius: 1rem;
		z-index: -1;
		position: absolute !important;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		overflow: hidden;
		display: flex;
		object-fit: cover;
		align-items: center;
		justify-content: center;
		width: 100% !important;
		height: 100% !important;
		filter: grayscale(0);

		img {
			max-width: unset;
			min-height: 100% !important;

			@include media-breakpoint-up(lg) {
				min-height: 100vw !important;
			}
		}
	}
}

.about-school {
	// background-color: white;
	// border-radius: 1rem;

	// padding: 1rem;
	// @include media-breakpoint-up(md) {
	// 	padding: 1.5rem;
	// }

	&__header {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		color: black;
		margin-bottom: 1rem;

		// span {
		// 	font-size: 0.8rem;
		// 	@include media-breakpoint-up(lg) {
		// 		font-size: 1.125rem;
		// 	}
		// }

		// &__title {
		// 	font-weight: 600;
		// 	line-height: normal;

		// 	font-size: 2rem !important;
		// 	@include media-breakpoint-up(lg) {
		// 		font-size: 5rem !important;
		// 	}
		// }
	}

	&__body {
		width: 100%;
		aspect-ratio: 21/9;
		@include media-breakpoint-down(md) {
			aspect-ratio: 16/10;
		}
		border-radius: 1rem;
		position: relative;
		overflow: hidden;

		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;

		color: white;
		padding: 1.5rem;
		z-index: 1;
		@include overlay_shadow;
		&::before {
			z-index: 0;
		}
	}

	.play_button {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		z-index: 1;
		color: white;

		.icon-play-rounded {
			border-radius: 50%;
			padding: 0.8rem;
			border: 4px solid white;
			font-size: 1.5rem;
		}

		.title.title-lg {
			 font-size: 1rem;
			 @include media-breakpoint-up(lg) {
 				font-size: 2rem;
 			}
		}
	}

	&__card {
		height: 118px;
		background-color: white;
		padding: 1rem;
		border-radius: 1rem;

		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		span {
			font-size: 0.8rem;
			@include media-breakpoint-up(lg) {
				font-size: 1rem;
			}
		}

		&__title {
			font-size: 1.3rem !important;
			@include media-breakpoint-up(lg) {
				font-size: 2.75rem !important;
			}
		}

		&-button {
			border: 1px solid $blue;
			color: $blue;
			&:hover {
				background-color: $blue;
				color: white;
			}
		}
	}
}
</style>
